(function () {
  'use strict';

  var SKIP_SELECTOR = 'script,style,textarea,input,code,pre,select,option,[data-no-ring],#shopify-admin-bar';
  var PERIOD_HTML = '<span class="price-ring" aria-hidden="true"></span>';
  var COLON_HTML =
    '<span class="colon-ring" aria-hidden="true">' +
    '<span class="price-ring" style="margin:0"></span>' +
    '<span class="price-ring" style="margin:0"></span>' +
    '</span>';

  function escapeHtml(str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function processTextNode(node) {
    var text = node.nodeValue;
    if (!text || (!text.includes('.') && !text.includes(':'))) return;
    if (text.includes('http') || text.includes('www.') || text.includes('@')) return;

    var parent = node.parentElement;
    if (!parent || parent.closest(SKIP_SELECTOR)) return;

    var html = escapeHtml(text)
      .replace(/\./g, PERIOD_HTML)
      .replace(/:/g, COLON_HTML);

    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    parent.replaceChild(tpl.content, node);
  }

  function walkAndProcess(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(processTextNode);
  }

  function run() {
    walkAndProcess(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var debounceTimer;
  var queued = new Set();

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var addedNodes = mutations[i].addedNodes;
      for (var j = 0; j < addedNodes.length; j++) {
        var node = addedNodes[j];
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        // Skip our own ring insertions to prevent re-processing loops
        if (node.classList.contains('price-ring') || node.classList.contains('colon-ring')) continue;
        queued.add(node);
      }
    }
    if (queued.size === 0) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      queued.forEach(function (n) {
        try { walkAndProcess(n); } catch (_) {}
      });
      queued.clear();
    }, 100);
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
